// Components
import GeneralInfo from './sections/GeneralInfo';
import MoveResources from './sections/MoveResources';
// Types
import type { IProps } from './sections/sections.interface';

const TimeZone = ({ timeZone, onChange }: IProps) => {
  if (!timeZone) return null;
  return (
    <>
      <GeneralInfo timeZone={timeZone} onChange={onChange} />
      {!!timeZone.id && (
        <MoveResources timeZone={timeZone} onChange={onChange} />
      )}
    </>
  );
};

export default TimeZone;
